<section>

    <sp-modal #modal title="PROCESS IMPORT REQUEST" (confirm)="onSubmit()" confirmButtonText="Process Import Request">
        <p>This action will import all {{ 'components' | terminology | async }}, photos, and other information associated with this data import request.</p>
        <p><i>Note: <strong>This process may take several minutes to complete</strong>. The import of photos is done asynchronously -- it may take some time until all photos are available for viewing.</i></p>
    </sp-modal>

    <form [formGroup]="formGroup">
        <div class="form-section">
            <div class="row margin-top-20">
                <div class="col-md-9">
                    <h2 class="title">PROPERTY DETAILS</h2>
                </div>
                <div class="col-md-3">
                    <a class="btn btn-primary" [routerLink]="['./export-map']">Manage Export Map</a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label>Property Name</label>
                </div>
                <div class="col-md-6">
                    <span>{{property.name}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <label>Workspace</label>
                </div>
                <div class="col-md-6">
                    <span>{{workspace?.companyName}}</span>
                </div>
            </div>
            <div class="row margin-bottom-20">
                <div class="col-md-3">
                    <label>Location</label>
                </div>
                <div class="col-md-6">
                    <span>{{property.city}}, {{property.state}}</span>
                </div>
            </div>
        </div>

        <div class="form-section">
            <div class="row margin-top-20">
                <div class="col-md-9">
                    <h2 class="title">CONNECTED APPS</h2>
                </div>
                <div class="col-md-3">
                    <a class="btn btn-primary" (click)="showAddConnectedAppModal()">{{ integrationProperty ? 'EDIT' : 'ADD' }} CONNECTED APP</a>
                </div>
            </div>
            <ng-container *ngIf="integrationProperty; else noIntegration">

                <div class="row">
                    <div class="col-md-3">
                        <label>Integrated Application</label>
                    </div>
                    <div class="col-md-6">
                        <span>{{integrationProperty?.integrationName}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <label>API Credentials</label>
                    </div>
                    <div class="col-md-6">
                        <span>{{integrationProperty?.integrationCredentialName}}</span>
                    </div>
                </div>
                <div class="row margin-bottom-20">
                    <div class="col-md-3">
                        <label>Association ID/Code</label>
                    </div>
                    <div class="col-md-6">
                        <span>{{integrationProperty?.externalPropertyCode}}</span>
                    </div>
                </div>
            </ng-container>
            <ng-template #noIntegration>
                <div class="row">
                    <div class="col-md-6">
                        <label> No Integrations have been setup.</label>
                    </div>
                </div>
            </ng-template>
        </div>
    </form>

    <sp-add-connected-app-modal #addConnectedAppModal 
        [propertyId]="property.propertyId"
    ></sp-add-connected-app-modal>
</section>

